import { isTopic } from '@tunein/web-common';
import PropTypes from 'prop-types';
import { useStores } from 'src/common/providers';
import FavoriteControlWithOptions from './FavoriteControlWithOptions';
import { FavoriteIconControl } from './FavoriteIconControl';

export function FavoriteControl({
  profileGuideItem,
  fill,
  hoverFill,
  showIconLabel,

  iconClassName,
  unFavoritedClassName,
}) {
  const { playerStore } = useStores();
  const tunedGuideId = playerStore.currentGuideItem()?.playableGuideId;
  const profilePlayableGuideId = profileGuideItem?.actions?.play?.guideId;
  let showControlWithOptions = !profilePlayableGuideId && isTopic(tunedGuideId);

  if (profilePlayableGuideId) {
    showControlWithOptions =
      profilePlayableGuideId === tunedGuideId && isTopic(profilePlayableGuideId);
  }

  return showControlWithOptions ? (
    <FavoriteControlWithOptions
      guideItem={profileGuideItem}
      showIconLabel={showIconLabel}
      fill={fill}
      iconClassName={iconClassName}
      unFavoritedClassName={unFavoritedClassName}
    />
  ) : (
    <FavoriteIconControl
      guideItem={profileGuideItem}
      fill={fill}
      hoverFill={hoverFill}
      showIconLabel={showIconLabel}
      iconClassName={iconClassName}
      unFavoritedClassName={unFavoritedClassName}
    />
  );
}

FavoriteControl.propTypes = {
  profileGuideId: PropTypes.string,
  fill: PropTypes.string,
  hoverFill: PropTypes.string,
  iconClassName: PropTypes.string,
  showIconLabel: PropTypes.bool,
  unFavoritedClassName: PropTypes.string,
};
